/**
 * 登录相关
 */

 import axios from '../utils/http';

 
// 确认用户手机号码的注册与否，再获取验证码
const confirmSms = (params) => {
    return axios.request({
        headers: {
            "useragent": "msb-iphone"
        },
        data: {
            ...params
        },
        method: 'post',
        url: '/v1/opcheck'
    })
}
// 注册或登录
// type true 注册 false 登录
const registerOrLogin = (type, params) => {
    return axios.request({
        headers: {
            "useragent": "msb-web"
        },
        data: {
            ...params
        },
        method: 'post',
        url: type ? '/v6/register' : '/v6/login'
    })
}
 export default {
    confirmSms,
    registerOrLogin
 }